import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import EditIcon from '@interxfi/design-system/icons/react/icon-edit';
import RocketIcon from '@interxfi/design-system/icons/react/icon-rocket';
import { O5RepoConfigureDrawer } from '../../../../../../../../features/o5/builds/github/o5-repo-configure-drawer';
import { O5RepoTriggerDrawer } from '../../../../../../../../features/o5/builds/github/o5-repo-trigger-drawer';
import { O5ReposTable } from '../../../../../../../../features/o5/builds/github/o5-repos-table';
import { getPageHead } from '../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_o5/_o5-required/tech-ops/build/repo/_repo/')({
  head: () => getPageHead('Repos'),
  component: O5BuildRepoList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <HorizontalStack align="end" blockAlign="center" gap={2} wrap="nowrap">
      <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
        <RequiresAccess write>
          <O5RepoTriggerDrawer
            trigger={
              <Button affixIcon={<RocketIcon aria-hidden />} size="small">
                Trigger
              </Button>
            }
          />
          <O5RepoConfigureDrawer
            trigger={
              <Button affixIcon={<EditIcon aria-hidden />} size="small">
                Configure
              </Button>
            }
          />
        </RequiresAccess>
        {filter}
      </HorizontalStack>
    </HorizontalStack>
  );
}

function O5BuildRepoList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <O5ReposTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
